import { API_URL } from "@/config";

import axios from "axios";

const httpInstance = axios.create({
  baseURL: API_URL
});

/**
 *
 * @param week
 * @returns {Promise<{rooms, weeks, success}|{success: boolean}>}
 */
export async function roomsApi(week) {
  try {
    let queryString = "";

    if (week) {
      queryString = `?week=${week}`;
    }

    const {
      data: { success, message, rooms, weeks }
    } = await httpInstance.get(`rooms${queryString}`);

    return {
      success,
      message,
      rooms,
      weeks
    };
  } catch (error) {
    console.error(error);
  }

  return {
    success: false
  };
}

/**
 *
 * @param roomHash
 * @param week
 * @param code
 * @returns {Promise<{success, message, order}|{success: boolean}>}
 */
export async function createOrderApi(roomHash, week, code) {
  try {
    if (!roomHash || !week || !code) {
      throw Error("Bad data.");
    }

    const {
      data: { success, message, order }
    } = await httpInstance.post(`createOrder`, {
      room_hash: roomHash,
      week,
      code
    });

    return {
      success,
      message,
      order
    };
  } catch (error) {
    console.error(error);
  }

  return {
    success: false
  };
}

/**
 *
 * @param hash
 * @returns {Promise<{success, message, order}|{success: boolean}>}
 */
export async function orderApi(hash) {
  if (!hash) {
    return {
      success: false
    };
  }

  try {
    const {
      data: { success, message, order }
    } = await httpInstance.get(`order?hash=${hash}`);

    return {
      success,
      message,
      order
    };
  } catch (error) {
    console.error(error);
  }

  return {
    success: false
  };
}

/**
 *
 * @param type
 * @returns {Promise<{success, services}|{success: boolean}>}
 */
const services = async (hash, type) => {
  try {
    const {
      data: { success, services }
    } = await httpInstance.get(`services?type=${type}&hash=${hash}`);

    return {
      success,
      services
    };
  } catch (error) {
    console.error(error);
  }

  return {
    success: false
  };
};

/**
 *
 * @returns {Promise<{success: *, services: *}|{success: boolean}>}
 */
export async function amountServicesApi(hash) {
  return services(hash, "catering");
}

/**
 *
 * @returns {Promise<{success: *, services: *}|{success: boolean}>}
 */
export async function selectServicesApi(hash) {
  return services(hash, "service");
}

/**
 *
 * @param {string} orderHash
 * @param {array} services
 * @returns {Promise<{success, message}|{success: boolean}>}
 */
export async function addServicesApi(orderHash, services) {
  try {
    if (!orderHash) {
      throw Error("Bad data.");
    }

    const {
      data: { success, message }
    } = await httpInstance.post(`services`, {
      hash: orderHash,
      services
    });

    return {
      success,
      message
    };
  } catch (error) {
    console.error(error);
  }

  return {
    success: false
  };
}

/**
 *
 * @param {string} orderHash
 * @param {object} data
 * @returns {Promise<{success, message}|{success: boolean}>}
 */
export async function saveExtraData(orderHash, data) {
  try {
    if (!orderHash || !data) {
      throw Error("Bad data.");
    }

    const {
      data: { success, message }
    } = await httpInstance.post(`saveExtraData`, {
      hash: orderHash,
      data
    });

    return {
      success,
      message
    };
  } catch (error) {
    console.error(error);
  }

  return {
    success: false
  };
}

/**
 *
 * @param {string} orderHash
 * @returns {Promise<{success, message}|{success: boolean}>}
 */
export async function addToBasketApi(orderHash) {
  try {
    if (!orderHash) {
      throw Error("Bad data.");
    }

    const {
      data: { success, message }
    } = await httpInstance.post(`addToBasket`, {
      hash: orderHash
    });

    return {
      success,
      message
    };
  } catch (error) {
    console.error(error);
  }

  return {
    success: false
  };
}

/**
 *
 * @param {string} orderHash
 * @param {string} key
 * @param value
 * @returns {Promise<{success, message}|{success: boolean}>}
 */
export async function saveOrderDataApi(orderHash, key, value = "") {
  try {
    if (!orderHash || !key) {
      throw Error("Bad data.");
    }

    const {
      data: { success, message }
    } = await httpInstance.post(`saveOrderData`, {
      hash: orderHash,
      key,
      value
    });

    return {
      success,
      message
    };
  } catch (error) {
    console.error(error);
  }

  return {
    success: false
  };
}

/**
 *
 * @param orderHash
 * @param bank
 * @returns {Promise<{success, message}|{success: boolean}>}
 */
export async function checkoutApi(orderHash, bank) {
  try {
    if (!orderHash || !bank) {
      throw Error("Bad data.");
    }

    const {
      data: { success, message, redirect, transaction_id }
    } = await httpInstance.post(`checkout`, {
      hash: orderHash,
      bank
    });

    return {
      success,
      message,
      redirect,
      transactionId: transaction_id
    };
  } catch (error) {
    console.error(error);
  }

  return {
    success: false,
    transactionId: '',
  };
}

export async function cancelOrderApi(hash) {
  if (!hash) {
    return {
      success: false
    };
  }

  try {
    const {
      data: { success, message }
    } = await httpInstance.post("cancelOrder", {
      hash
    });

    return {
      success,
      message
    };
  } catch (error) {
    console.error(error);
  }

  return {
    success: false
  };
}

export async function adminBlockTimeApi(hash) {
  if (!hash) {
    return {
      success: false
    };
  }

  try {
    const {
      data: { success, message }
    } = await httpInstance.post("adminBlockTime", {
      hash
    });

    return {
      success,
      message
    };
  } catch (error) {
    console.error(error);
  }

  return {
    success: false
  };
}
